module.exports = __webpack_public_path__ + "img/s1r.acf1f705.gif";